import TaraLandingPage from './TaraLandingPage';
export default TaraLandingPage;
